import { Metamodel } from '../../base/model';
import { IAdsAdlsGen2CommonProperties } from './AdsAdlsGen2CommonProperties';
import { AdsDataset, AdsDatasetType, IAdsDatasetArgs } from './AdsDatasetModel';

interface IAdsAdlsGen2FolderDatasetProperties extends IAdsAdlsGen2CommonProperties  {
    folderName: string;
    path: string;
}

export type IAdsAdlsGen2FolderDatasetArgs = Omit<IAdsDatasetArgs<IAdsAdlsGen2FolderDatasetProperties>, 'datasetType'>;

@Metamodel.model({
    name: 'AdsAdlsGen2FolderDataset'
})
export class AdsAdlsGen2FolderDataset extends AdsDataset<IAdsAdlsGen2FolderDatasetProperties> {
    public constructor(args: IAdsAdlsGen2FolderDatasetArgs) {
        super({
            ...args,
            datasetType: AdsDatasetType.AdlsGen2Folder
        });
    }

    public get resourceId(): string {
        const path = this.properties.path ? this.properties.path + '/' : '';
        return `${this.properties.storageAccountName}/${this.properties.filesystemName}/${path}${this.properties.folderName}`;
    }
}
